var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [
      _vm._v(
        " " +
          _vm._s(
            _vm.user.id != null
              ? _vm.$t("settings.users.userEdit")
              : _vm.$t("settings.users.userNew")
          ) +
          " "
      )
    ]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("user-settings-menu"),
        _c(
          "v-card",
          [
            _c(
              "v-card-text",
              [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.formValid,
                      callback: function($$v) {
                        _vm.formValid = $$v
                      },
                      expression: "formValid"
                    }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("settings.users.additionalData.position")
                      },
                      model: {
                        value: _vm.user.position,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "position", $$v)
                        },
                        expression: "user.position"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.additionalData.department"
                        )
                      },
                      model: {
                        value: _vm.user.department,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "department", $$v)
                        },
                        expression: "user.department"
                      }
                    }),
                    _c("v-textarea", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.additionalData.responsibilities"
                        )
                      },
                      model: {
                        value: _vm.user.responsibilities,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "responsibilities", $$v)
                        },
                        expression: "user.responsibilities"
                      }
                    }),
                    _c("v-select", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.additionalData.paymentType"
                        ),
                        items: _vm.paymentTypes
                      },
                      model: {
                        value: _vm.user.payment_type,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "payment_type", $$v)
                        },
                        expression: "user.payment_type"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: { label: "PKP Intercity Login" },
                      model: {
                        value: _vm.user.pkp_intercity_login,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "pkp_intercity_login", $$v)
                        },
                        expression: "user.pkp_intercity_login"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: { label: "PKP Intercity password" },
                      model: {
                        value: _vm.user.pkp_intercity_password,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "pkp_intercity_password", $$v)
                        },
                        expression: "user.pkp_intercity_password"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled:
                        !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }